import { render } from "./Report.vue?vue&type=template&id=675b596e&scoped=true&ts=true"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"

import "./Report.vue?vue&type=style&index=0&id=675b596e&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675b596e"]])

export default __exports__